import { Routes, Route, useLocation } from "react-router-dom";
import { PAGES } from "./constants/pages";
import HomePage from "./pages/HomePage";
import ServicePage from "./pages/ServicePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import { useLayoutEffect, type ReactNode } from "react";
import LicencePage from "./pages/LicencePage/LicencePage";

const Wrapper: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return children;
};

const AppRouter = () => {
  return (
    <Wrapper>
      <Routes>
        <Route path={PAGES.BASE.route} element={<HomePage />} />
        <Route path={PAGES.HOME.route} element={<HomePage />} />
        <Route path={PAGES.ABOUT.route} element={<AboutPage />} />
        <Route path={PAGES.CONTACT.route} element={<ContactPage />} />
        <Route path={PAGES.LICENSE.route} element={<LicencePage />} />
        <Route
          path={PAGES.WORK_SAFETY_HEALTH.route}
          element={<ServicePage i18nKey={PAGES.WORK_SAFETY_HEALTH.i18nKey} />}
        />
        <Route
          path={PAGES.SITE_SAFETY_COORDINATOR.route}
          element={
            <ServicePage i18nKey={PAGES.SITE_SAFETY_COORDINATOR.i18nKey} />
          }
        />
        <Route
          path={PAGES.ENERGY_EFFICIENCY.route}
          element={<ServicePage i18nKey={PAGES.ENERGY_EFFICIENCY.i18nKey} />}
        />
        <Route
          path={PAGES.GEO_INFRA_MONITORING.route}
          element={<ServicePage i18nKey={PAGES.GEO_INFRA_MONITORING.i18nKey} />}
        />
        <Route
          path={PAGES.SUPERVISION.route}
          element={<ServicePage i18nKey={PAGES.SUPERVISION.i18nKey} />}
        />
        <Route
          path={PAGES.PREDICTIVE_MAINTENANCE.route}
          element={
            <ServicePage i18nKey={PAGES.PREDICTIVE_MAINTENANCE.i18nKey} />
          }
        />
        <Route
          path={PAGES.DESIGN.route}
          element={<ServicePage i18nKey={PAGES.DESIGN.i18nKey} />}
        />
        <Route
          path={PAGES.FIRE_PROTECTION.route}
          element={<ServicePage i18nKey={PAGES.FIRE_PROTECTION.i18nKey} />}
        />
        <Route
          path={PAGES.ENVIRONMENTAL_PROTECTION.route}
          element={
            <ServicePage i18nKey={PAGES.ENVIRONMENTAL_PROTECTION.i18nKey} />
          }
        />
        {/*<Route
        path={PAGES.STANDARDIZATION.route}
        element={<ServicePage i18nKey={PAGES.STANDARDIZATION.i18nKey} />}
      />*/}
        <Route
          path={PAGES.FIRST_AID.route}
          element={<ServicePage i18nKey={PAGES.FIRST_AID.i18nKey} />}
        />
        <Route
          path={PAGES.PROFESSIONAL_TRAINING.route}
          element={
            <ServicePage i18nKey={PAGES.PROFESSIONAL_TRAINING.i18nKey} />
          }
        />
        <Route
          path={PAGES.INSPECTIONS_TESTING.route}
          element={<ServicePage i18nKey={PAGES.INSPECTIONS_TESTING.i18nKey} />}
        />

        <Route path="*" element={<HomePage />} />
      </Routes>
    </Wrapper>
  );
};
export default AppRouter;
